<template>
  <refonte-card>
    <refonte-filters-tabs>
      <RefonteFiltersTabsItem
        v-for="(component, key) in sub_components_list"
        v-bind:key="key"
        v-bind:label="labels[key]"
        v-bind:selected="activeKey === key"
        v-bind:on_click="() => handleClick(key)" />
    </refonte-filters-tabs>
  </refonte-card>

  <RefonteCard>
    <div class="mt-4 max-h-[70vh] overflow-y-auto">
      <component v-bind:is="sub_components_list[activeKey]" />
    </div>
  </RefonteCard>
</template>
<script setup lang="ts">
  import { onMounted, ref, watch } from 'vue';
  import { useRoute, useRouter } from 'vue-router';
  import RefonteFiltersTabsItem from '@/components/refonte/filters/refonte-filters-tabs-item.vue';
  import RefonteCard from '@/components/refonte/cards/refonte-card.vue';
  import RefonteFiltersTabs from '@/components/refonte/filters/refonte-filters-tabs.vue';

  const props = defineProps<{
    sub_components_list: Record<string, any>;
    labels: Record<string, string>;
    default_key?: string;
    sync_with_route?: boolean;
  }>();

  const route = useRoute();
  const router = useRouter();

  onMounted(() => {
    if (props.sync_with_route) {
      const currentTab = route.query.tab as string | undefined;
      if (!currentTab || !(currentTab in props.sub_components_list)) {
        router.replace({
          path: route.path,
          query: {
            ...route.query,
            tab: props.default_key ?? Object.keys(props.sub_components_list)[0]
          }
        });
      }
    }
  });
  const activeKey = ref(
    props.sync_with_route
      ? ((route.query.tab as string) ??
          props.default_key ??
          Object.keys(props.sub_components_list)[0])
      : (props.default_key ?? Object.keys(props.sub_components_list)[0])
  );

  watch(
    () => route.query.tab,
    (newTab) => {
      if (newTab && newTab in props.sub_components_list) {
        activeKey.value = newTab as string;
      }
    }
  );

  function handleClick(key: string) {
    if (key in props.sub_components_list) {
      activeKey.value = key;
      if (props.sync_with_route) {
        router.push({
          path: route.path,
          query: { ...route.query, tab: key }
        });
      }
    }
  }
</script>

<style lang="scss" scoped>
  .refonte-filters-tabs {
    @apply flex flex-wrap items-center justify-end self-stretch;
    gap: 4px;
    border-radius: 8px;

    .filters-tabs-list {
      @apply flex flex-grow flex-wrap items-center self-stretch;
      gap: 6px;
    }
  }
</style>
